import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import AuthHelper from './helpers/auth';

/* layouts */
import BasicLayout from './layouts/basic-layout';

/* containers */
import LoginPage from './containers/LoginPage';
import CallbackCasPage from './containers/CallbackCasPage';
import LogoutPage from './containers/LogoutPage';
import UnauthorizedPage from './containers/UnauthorizedPage';
import CallbackJrUpgPage from './containers/CallbackJrUpgPage';
import CallbackJSUPPage from './containers/CallbackJSUPPage';
import PaymentFailurePage from './containers/PaymentFailurePage';
import PaymentSuccessPage from './containers/PaymentSuccessPage';

// Ticket Page
import TicketPage from './containers/TicketPage';
import ReserveMachinePage from './containers/ReserveMachinePage';

// Purchase History Page
import PurchaseHistoryPage from './containers/PurchaseHistoryPage';
import TicketDetailPage from './containers/TicketDetailPage';

const routes = [
	{ path: '/callback/jr_upg/success', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackJrUpgPage },
	{ path: '/callback/jsup/success', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackJSUPPage },
	{ path: '/payment/failure', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: PaymentFailurePage },
	{ path: '/payment/success', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: PaymentSuccessPage },
	{ path: '/unauthorized', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: UnauthorizedPage },
	{ path: '/login', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: LoginPage },
	{ path: '/callback/cas', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackCasPage },
	{ path: '/logout', exact: true, isPrivate: false, Layout: BasicLayout, layoutClass: 'narrow', Component: LogoutPage },

	// Tickets / Home Page
	{ path: '/tickets', exact: true, isPrivate: true, Layout: BasicLayout, layoutClass: 'narrow', Component: TicketPage },

	// Ticket Detail Page
	{ path: '/tickets/id', exact: true, isPrivate: true, Layout: BasicLayout, layoutClass: 'narrow', Component: TicketDetailPage },
	{ path: '/tickets/id/reserve-machine', exact: true, isPrivate: true, Layout: BasicLayout, layoutClass: 'narrow', Component: ReserveMachinePage },

	// Purchase History Page
	{ path: '/purchase-history', exact: true, isPrivate: true, Layout: BasicLayout, layoutClass: 'narrow', Component: PurchaseHistoryPage },
	{ path: '/purchase-history/ticket', exact: true, isPrivate: true, Layout: BasicLayout, layoutClass: 'narrow', Component: TicketDetailPage }
];

function getRedirectedPath(location) {
	if (
		location.pathname.split('?')[0] === '/login'
		&& location.pathname.split('?').length > 1
	) {
		return location.pathname + location.search + location.hash;
	}

	// skip the redirection from these routes
	if (
		[
			'/login',
			'/callback/cas',
			'/logout'
		].indexOf(location.pathname.split('?')[0]) !== -1) {
		return '/login';
	}
	return `/login?path=${location.pathname + location.search + location.hash}`;
}


const PrivateRoute = ({ layout: Layout, layoutClass, component: Component, ...rest }) => (
	<Route
		{...rest}
		render={props => {
			if (AuthHelper.isAuthenticated()) {
				return (
					<Layout containerClass={layoutClass}>
						<Component {...props} />
					</Layout>
				);
			} else {
				return (
					<Redirect
						to={{
							pathname: getRedirectedPath(props.location),
							state: { from: props.location }
						}}
					/>
				);
			}
		}}
	/>
);

export class Routes extends Component {
	render() {
		const { location } = this.props;
		return (
			<Switch location={location}>
				{routes.map(({ path, exact, isPrivate, Layout, layoutClass, Component }) => {
					if (isPrivate) {
						return (
							<PrivateRoute
								key={0}
								path={path}
								exact={exact}
								layout={Layout}
								layoutClass={layoutClass}
								component={Component}
							/>
						);
					} else {
						return (
							<Route
								key={0}
								path={path}
								exact={exact}
								render={props => (
									<Layout
										containerClass={layoutClass}
										location={location}
									>
										<Component {...props} />
									</Layout>
								)}
							/>
						);
					}
				})}
				<Route render={props => (AuthHelper.isAuthenticated() ? <Redirect to={'/tickets'} /> : <Redirect to={getRedirectedPath(props.location)} />)} />
			</Switch>
		);
	}
}

export default withRouter(Routes);
